import { Stack, Typography } from "@mui/material";
import { FC, useMemo } from "react";
import { getStyles } from "./styles";

interface IProps {
  title: string;
  description?: string;
}

export const EmptyPage: FC<IProps> = ({ title, description }) => {
  const styles = useMemo(() => getStyles(), []);

  return (
    <Stack sx={styles.container} justifyContent="center" alignItems="center">
      <img
        src="/images/user/empty_page.png"
        alt="empty_page"
        width={155}
        height={155}
      />
      <Typography variant="h6" fontWeight={600} mt={1}>
        {title}
      </Typography>
      {description && (
        <Typography variant="body1" width="570px" textAlign="center" mt={1}>
          {description}
        </Typography>
      )}
    </Stack>
  );
};
